import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarDays } from "lucide-react";
import { getCalendarStatus, type CalendarEventRow } from "@/lib/partnerGoogleCalendar";

/** Compact Home widget for synced Google Calendar events. */
export function PartnerUpcomingCalendar() {
  const [events, setEvents] = useState<CalendarEventRow[]>([]);
  const [connected, setConnected] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      const res = await getCalendarStatus();
      if (cancelled) return;
      setConnected(Boolean(res.connected));
      setEvents(res.events || []);
      setLoaded(true);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!loaded || !connected) return null;
  if (events.length === 0) return null;

  return (
    <section>
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-bold uppercase tracking-wide text-gray-500 flex items-center gap-2">
          <CalendarDays className="h-3.5 w-3.5" />
          Calendar
        </h3>
        <Link
          to="/partners/settings"
          className="text-sm font-semibold text-skutopia-600 hover:text-skutopia-700"
        >
          Manage
        </Link>
      </div>
      <div className="rounded-xl border border-[#d0d7de] bg-white divide-y divide-gray-100">
        {events.slice(0, 5).map((ev) => (
          <div key={ev.id} className="flex items-center justify-between gap-3 px-5 py-3">
            <div className="min-w-0">
              <p className="text-sm font-semibold text-gray-900 truncate">{ev.title || "Event"}</p>
              <p className="text-xs text-gray-500 capitalize">{ev.event_type}</p>
            </div>
            <span className="text-xs text-gray-500 shrink-0">
              {ev.event_start
                ? new Date(ev.event_start).toLocaleDateString(undefined, {
                    month: "short",
                    day: "numeric",
                  })
                : "—"}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
